import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TooltipViewportPosition } from '@tripointe/tripointe-cms/types';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  showTooltip: BehaviorSubject<TooltipViewportPosition> = new BehaviorSubject(null);
  constructor() {
    window.addEventListener('scroll', () => {
      if (this.showTooltip.getValue()) this.showTooltip.next(null);
    });
  }
}
